export default __webpack_public_path__ + "static/media/profile-img2.a30cbec6.jpg";